import React from 'react';
import { PetType, PetTypeIds } from '@spike/model';
import { usePetChipStyles } from 'components/UI/V2/Pets/PetChip/PetChip.styles';
import { faCat, faDog, faTurtle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

interface PetChipProps {
    petName: string;
    petType: PetType;
    active?: boolean;
    className?: string;
    onClick?: () => void;
}

export const PetChip: React.FC<PetChipProps> = props => {
    const classes = usePetChipStyles();

    const petIcon = React.useMemo(() => {
        if (props.petType.id === PetTypeIds.DOGS) {
            return <FontAwesomeIcon icon={faDog} />;
        }

        if (props.petType.id === PetTypeIds.CATS) {
            return <FontAwesomeIcon icon={faCat} />;
        }

        if (props.petType.id === PetTypeIds.EXOTICS) {
            return <FontAwesomeIcon icon={faTurtle} />;
        }

        return null;
    }, [props.petType]);

    return (
        <button
            onClick={props.onClick}
            className={clsx(classes.root, props.className, {
                [classes.active]: props.active,
                [classes.bgDog]: props.petType.id === PetTypeIds.DOGS,
                [classes.bgCat]: props.petType.id === PetTypeIds.CATS,
                [classes.bgExotic]: props.petType.id === PetTypeIds.EXOTICS
            })}
        >
            <span
                className={clsx(classes.icon, {
                    [classes.iconDog]: props.petType.id === PetTypeIds.DOGS,
                    [classes.iconCat]: props.petType.id === PetTypeIds.CATS,
                    [classes.iconExotic]: props.petType.id === PetTypeIds.EXOTICS
                })}
            >
                {petIcon}
            </span>

            <span className={classes.petName}>{props.petName}</span>
        </button>
    );
};
